import { download, map, slideshow, social_sharing } from "../settings";
import useMeowLightboxContext from "../context";
import { useController } from "../helpers";
import { MwlIcons } from "../components/MwlIcons";

export const Actions = () => {

  const { image, currentUrl, isPlaying, isExtended, isMapOpen} = useMeowLightboxContext();
  const { onCloseClick, onDownloadClick, onPlayClick, onPauseClick, onMapClick,
    onFullscreenClick, onShrinkClick } = useController();

  const items = [
    {
      visible: Boolean(social_sharing),
      icon: 'sharing',
      className: 'mwl__topbar__controls__control--sharing',
      children : currentUrl && (
        <div className="mwl__topbar__controls__control--sharing__options">
          <li><a href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank">Share on Facebook</a></li>
          <li><a href={`https://twitter.com/intent/tweet?text=${currentUrl}`} target="_blank">Share on Twitter</a></li>
          <li><a href={`https://pinterest.com/pin/create/button/?url=${currentUrl}`} target="_blank">Share on Pinterest</a></li>
        </div>
      )
    },
    {
      visible: download.enabled && image.download_link,
      label: 'Download Image',
      icon: 'download',
      onClick: onDownloadClick,
      className: 'mwl__topbar__controls__control--download'
    },
    {
      visible: slideshow.enabled,
      label: 'Start slideshow',
      icon: 'play',
      onClick: onPlayClick,
      className: `mwl__topbar__controls__control--play ${isPlaying ? "hidden" : ""}`
    },
    {
      visible: slideshow.enabled,
      label: 'Stop slideshow',
      icon: 'pause',
      onClick: onPauseClick,
      className: `mwl__topbar__controls__control--pause ${!isPlaying ? "hidden" : ""}`
    },
    {
      visible: map.enabled && image.gps && image.gps.lat !== "N/A" && image.gps.lng !== "N/A",
      label: isMapOpen ? 'Show image' : 'Show on map',
      icon: isMapOpen ? 'image' : 'map',
      onClick: onMapClick,
      className: 'mwl__topbar__controls__control--map'
    },
    {
      visible: true,
      label: 'Full screen',
      icon: 'fullscreen',
      onClick: onFullscreenClick,
      className: `mwl__topbar__controls__control--fullscreen ${isExtended ? "hidden" : ""}`
    },{
      visible: true,
      label: 'Shrink',
      icon: 'shrink',
      onClick: onShrinkClick,
      className: `mwl__topbar__controls__control--shrink ${!isExtended ? "hidden" : ""}`
    },
    {
      visible: true,
      label: 'Close',
      icon: 'close',
      onClick: onCloseClick,
      className: 'mwl__topbar__controls__control--close',
    }
  ];

  return items.filter(v => v.visible)
    .map(({ children, label, icon, onClick, className }) =>
      <div className={`mwl__topbar__controls__control ${className}`}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) {
            onClick();
          }
        }}
      >
        <MwlIcons icon={icon} />
        {!!label && <div className="mwl__topbar__controls__control__label">{label}</div>}
        {children}
      </div>
    );
};
